import type { SVGProps } from 'react'

/**
 * BubbleChatPreview icon component
 * @param props - SVG properties including className, fill, etc.
 */
export function BubbleChatPreview(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.208 0.73C9.47 0.73 8.84 1.04 8.37 1.39C7.89 1.74 7.55 2.16 7.35 2.42C7.29 2.5 7.15 2.68 7.15 2.92C7.15 3.149 7.29 3.34 7.35 3.42C7.55 3.68 7.89 4.09 8.37 4.44C8.84 4.79 9.47 5.1 10.208 5.1C10.95 5.1 11.58 4.79 12.05 4.44C12.52 4.09 12.87 3.68 13.06 3.42C13.126 3.34 13.27 3.149 13.27 2.92C13.27 2.68 13.126 2.5 13.06 2.42C12.87 2.16 12.52 1.74 12.05 1.39C11.58 1.04 10.95 0.73 10.208 0.73ZM10.2 2.04C9.72 2.04 9.33 2.43 9.33 2.92C9.33 3.4 9.72 3.79 10.2 3.79H10.21C10.693 3.79 11.083 3.4 11.083 2.92C11.083 2.43 10.693 2.04 10.21 2.04H10.2Z'
        fill='currentColor'
      />
      <path
        d='M7 0.73C7.25 0.73 7.38 0.73 7.43 0.79C7.45 0.82 7.47 0.85 7.47 0.89C7.48 0.97 7.38 1.07 7.19 1.27C6.96 1.5 6.78 1.72 6.66 1.88L6.65 1.89C6.58 1.98 6.27 2.38 6.27 2.92C6.27 3.46 6.58 3.85 6.65 3.94L6.66 3.95C6.88 4.24 7.28 4.73 7.85 5.14C8.41 5.56 9.22 5.98 10.208 5.98C11.2 5.98 12.01 5.56 12.57 5.14C12.74 5.02 12.83 4.96 12.9 4.97C12.92 4.97 12.93 4.98 12.95 4.99C13.02 5.02 13.04 5.12 13.09 5.3C13.21 5.76 13.27 6.25 13.27 6.75C13.27 10.09 10.44 12.77 7 12.77C6.59 12.766 6.19 12.73 5.79 12.65C5.65 12.63 5.56 12.61 5.5 12.6C5.45 12.595 5.4 12.613 5.38 12.623C5.32 12.65 5.23 12.7 5.09 12.77C4.26 13.22 3.28 13.38 2.34 13.2C2.19 13.17 2.06 13.07 2.01 12.92C1.96 12.777 1.98 12.61 2.08 12.5C2.35 12.16 2.543 11.75 2.63 11.32C2.65 11.2 2.6 11.04 2.44 10.88C1.38 9.8 0.73 8.35 0.73 6.75C0.73 3.41 3.56 0.73 7 0.73ZM4.67 6.42C4.34 6.42 4.08 6.68 4.08 7C4.08 7.32 4.34 7.58 4.67 7.58H4.67C4.99 7.58 5.25 7.32 5.25 7C5.25 6.68 4.99 6.42 4.67 6.42H4.67ZM7 6.42C6.68 6.42 6.41 6.68 6.41 7C6.41 7.322 6.68 7.58 7 7.58H7C7.32 7.58 7.59 7.322 7.59 7C7.59 6.68 7.32 6.42 7 6.42H7ZM9.33 6.42C9.01 6.42 8.75 6.68 8.75 7C8.75 7.32 9.01 7.58 9.33 7.58H9.34C9.66 7.58 9.92 7.32 9.92 7C9.92 6.68 9.66 6.42 9.34 6.42H9.33Z'
        fill='currentColor'
      />
    </svg>
  )
}
